import { AnaColumn } from "../forms-template.service";

export const consumoRegistriXml: AnaColumn[] = [
    {
    itemType: "group", colCount: "2", class: 'no-line-caption mt-4',
     data: [ // class: 'mt-5'
      {
        type: 'campo',
        dataField: "dbInstance",
        class:'database_consultant',
        nCol: 10,
        dataType: "",
        caption: "Host"
        // validation: [{
        //   type: 'required', message: 'È richiesto un titolo'
        // },
        //]
      },
     

     
    ]
  },
]